import { summon, AType } from "@silversea-ssc/functional-support"
import { InclusionCode as WebInclusionCode, inclusionKeys } from "@silversea-ssc/web-inclusions"

export const InclusionCode = summon<string, WebInclusionCode>((F) => F.keysOf(inclusionKeys()))
export type InclusionCode = WebInclusionCode

export const InclusionGeneric = summon((F) =>
    F.interface(
        {
            inclusionCode: InclusionCode(F),
        },
        "InclusionGeneric",
    ),
)
export type InclusionGeneric = AType<typeof InclusionGeneric>

const _Inclusion = InclusionGeneric
export const Inclusion = Object.assign(_Inclusion, {
    of: (inclusionCode: InclusionCode): Inclusion => _Inclusion.build({ inclusionCode }),
    listOf: (...inclusionCodes: InclusionCode[]): readonly Inclusion[] => inclusionCodes.map(Inclusion.of),
})
export type Inclusion = AType<typeof _Inclusion>
